module.exports = __webpack_public_path__ + "img/IMG_2493_L_Wood.71bfd1a9.jpg";